module.exports = __webpack_public_path__ + "img/gold.e7db0802.png";